<template>
  <div class="cp-material">
    <Close is-mobile @close="handleClose" class="close"></Close>
  </div>
</template>

<script>
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import Close from '~/components/Close/close.vue';
import Alert from "~/components/Alert";

export default {
  name: 'material',
  components: {Close},
  props: {
    material: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isHome: false,
      isDownload: false,
      isShare: false
    }
  },
  mounted() {
  },
  methods: {
    onCopy: function (e) {
      Alert('复制成功~')
    },
    onError: function (e) {
      Alert('复制失败!')
    },
    handleClose() {
      store.commit(types.HIDE_MODAL);
    },
    handleAddress() {
      store.commit(types.SHOW_MODAL2, {type: "address"});
    }
  }
};
</script>

<style lang="stylus" scoped>
  .cp-material
    position absolute
    width 6.66rem
    height 8.72rem
    background-image url('./images/modal.png')
    background-size: 6.66rem 8.02rem;
    background-repeat: no-repeat;
    background-position 0 0
    .desc
      position absolute
      top 1.51rem
      width 100%
      height 0.3rem
      font-size 0.3rem
      line-height 1
      text-align center
      color #060001
      font-weight bold
    .rule
      position absolute
      top 6.43rem
      width 100%
      height 0.24rem
      font-size 0.24rem
      line-height 1
      text-align center

@keyframes fadeIn {
  from {
    opacity 0
  }
  to {
    opacity: 1
  }
}
</style>
